module.exports = require("./hyphen.js");



//////////////////
// WEBPACK FOOTER
// ./node_modules/hyphen/index.js
// module id = 1239
// module chunks = 0